import React from 'react';
import * as SCm from './MobileAside.style';

interface Props {
  /** informacja o tym czy panel jest otwarty */
  opened: boolean;
  /** dzieci panelu */
  children: React.ReactNode;
}

/**
 * Komponent, który posiada możliwość otworzenia panelu bocznego dla widoku mobilnego
 *
 */
const MobileAside: React.FC<Props> = (props: Props) => <SCm.Aside opened={props.opened}>{props.children}</SCm.Aside>;

export default MobileAside;
